(function () {
  const LOAD_TIMEOUT_MS = 15000;
  const LOADED_ATTR = 'partnershipFormLoaded';

  function getVisibleForm(host) {
    return host.querySelector('[data-airtable-form]:not([hidden])');
  }

  function getLoadingEl(host) {
    return host.querySelector('.collaboration-partnership-form__loading');
  }

  function getIframe(form) {
    if (!form) return null;
    return form.querySelector('iframe.airtable-embed, iframe');
  }

  function isIframeLoaded(iframe) {
    return iframe && iframe.dataset[LOADED_ATTR] === 'true';
  }

  function markIframeLoaded(iframe) {
    if (iframe) iframe.dataset[LOADED_ATTR] = 'true';
  }

  function showLoading(host) {
    const loading = getLoadingEl(host);
    if (loading) loading.classList.remove('hidden');
    host.setAttribute('aria-busy', 'true');
  }

  function hideLoading(host) {
    const loading = getLoadingEl(host);
    if (loading) loading.classList.add('hidden');
    host.removeAttribute('aria-busy');
  }

  function bindIframeLoad(host, iframe, form) {
    if (!iframe || isIframeLoaded(iframe)) return;

    if (iframe._partnershipFormLoadBound) return;
    iframe._partnershipFormLoadBound = true;

    const onLoad = () => {
      markIframeLoaded(iframe);
      if (getVisibleForm(host) === form) {
        hideLoading(host);
      }
    };

    iframe.addEventListener('load', onLoad, { once: true });

    iframe._partnershipFormLoadTimer = window.setTimeout(() => {
      if (!isIframeLoaded(iframe)) {
        markIframeLoaded(iframe);
        if (getVisibleForm(host) === form) {
          hideLoading(host);
        }
      }
    }, LOAD_TIMEOUT_MS);
  }

  function bindBackgroundLoads(host) {
    host.querySelectorAll('[data-airtable-form]').forEach((form) => {
      const iframe = getIframe(form);
      if (iframe) bindIframeLoad(host, iframe, form);
    });
  }

  function syncVisibleFormLoading(host) {
    const form = getVisibleForm(host);
    const iframe = getIframe(form);

    if (!iframe) {
      hideLoading(host);
      return;
    }

    if (isIframeLoaded(iframe)) {
      hideLoading(host);
      return;
    }

    showLoading(host);
    bindIframeLoad(host, iframe, form);
  }

  function bindHost(host) {
    if (host.dataset.partnershipFormHostBound === 'true') return;
    host.dataset.partnershipFormHostBound = 'true';

    bindBackgroundLoads(host);
    syncVisibleFormLoading(host);

    const observer = new MutationObserver(() => {
      syncVisibleFormLoading(host);
    });

    host.querySelectorAll('[data-airtable-form]').forEach((form) => {
      observer.observe(form, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  function init() {
    document.querySelectorAll('[data-partnership-form-host]').forEach(bindHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
